import { Typography, Paper } from '@mui/material';

function Panel({ title, text }) {
  return (
    <Paper variant="outlined" sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Typography color="text.secondary">{text}</Typography>
    </Paper>
  );
}

export default Panel;
